const client = 'bada'
const brand = process.env.CONFIG_BRAND || 'magnet'
const env = process.env.CONFIG_PROFILE
const environment = env === 'local' ? 'dev' : env
const envUrlPart = environment !== 'prod' ? `.${environment}` : ''

const baseSettings = {
  environment,
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=',
  excludedStudioTypes: ['hidden'],
  cloudinaryFetchUrl: 'https://assets.nobiadigital.com/image/fetch/',
  cloudinaryUploadUrl: 'https://assets.nobiadigital.com/image/upload/',
  serviceDuration: 90,
  preferIplocation: true,
  postcodeRegex: '.*',
  badaConfigApiUrl: `https://bada-config${envUrlPart}.nobiadigital.com`,
  badaAppointmentApiUrl: `https://bada-appointment${envUrlPart}.nobiadigital.com/api`,
  ipLocationAPI: `https://bada-appointment${envUrlPart}.nobiadigital.com/api/location/ip`,
  gatewayAPI: `https://bada-gateway-api${envUrlPart}.nobiadigital.com/graphql?brand=${brand}&client=${client}`,
  trackingAPI: `https://my-project-api${envUrlPart}.nobiadigital.com`,
  azureAuthorization: {
    authorizeEndpoint: `https://auth-scripts-api${envUrlPart}.nobiadigital.com/authorize`,
    tokenEndpoint: `https://auth-scripts-api${envUrlPart}.nobiadigital.com/authorize-code`,
    refreshEndpoint: `https://auth-scripts-api${envUrlPart}.nobiadigital.com/refresh`,
    storageReturnUrlKey: `login-return-url-${env}`,
    storageTokenKey: `azure-token-${env}`,
    provider: 'Azure',
  },
}

const baseDevSettings = {
  uploads: {
    requestUrl: 'https://omniuploadsdev.blob.core.windows.net',
    signatureUrl:
      'https://bada-appointment.dev.nobiadigital.com/api/uploads/signature-full',
    successUrl:
      'https://bada-appointment.dev.nobiadigital.com/api/uploads/success',
  },
  appInsights: {
    instrumentationKey: '59910790-af09-465e-8438-8a4ed5f51bca',
  },
}

const baseTestSettings = {
  uploads: {
    requestUrl: 'https://omniuploadstest.blob.core.windows.net',
    signatureUrl:
      'https://bada-appointment.test.nobiadigital.com/api/uploads/signature-full',
    successUrl:
      'https://bada-appointment.test.nobiadigital.com/api/uploads/success',
  },
  appInsights: {
    instrumentationKey: '0ed8f904-4062-49c1-a39a-dbe8f02bfba4',
  },
}

const baseStageSettings = {
  uploads: {
    requestUrl: 'https://omniuploadsstage.blob.core.windows.net',
    signatureUrl:
      'https://bada-appointment.stage.nobiadigital.com/api/uploads/signature-full',
    successUrl:
      'https://bada-appointment.stage.nobiadigital.com/api/uploads/success',
  },
  appInsights: {
    instrumentationKey: '2e05e239-2c73-41d6-97e5-a3ef0e785168',
  },
}

const baseProdSettings = {
  uploads: {
    requestUrl: 'https://omniuploadsprod.blob.core.windows.net',
    signatureUrl:
      'https://bada-appointment.nobiadigital.com/api/uploads/signature-full',
    successUrl: 'https://bada-appointment.nobiadigital.com/api/uploads/success',
  },
  appInsights: {
    instrumentationKey: '78220050-9837-4fc7-926d-c70a062bb2e7',
  },
}

module.exports = {
  baseSettings,
  baseDevSettings,
  baseTestSettings,
  baseStageSettings,
  baseProdSettings,
  client,
  brand,
  environment,
}
